import { Controller } from "@hotwired/stimulus"
import { lock, unlock } from 'tua-body-scroll-lock'

export default class extends Controller {
  static targets = ["submit", "checkbox"]

  static values = {
    show: Boolean,
  }

  connect() {
    if (this.showValue) {
      this.showTimeout = setTimeout(() => {
        this.element.classList.add("active")
      }, 100)
    }
    if (this.hasCheckboxTarget) {
      this.setSubmitDisabled(true)
    }
    this.boundHandleKeyDown = this.handleKeyDown.bind(this)
    document.addEventListener('keydown', this.boundHandleKeyDown)
  }

  disconnect() {
    clearTimeout(this.showTimeout)
    document.removeEventListener('keydown', this.boundHandleKeyDown)
  }

  handleKeyDown(event) {
    if (!this.element.classList.contains("active")) {
      return
    }
    if (event.key === 'Escape') {
      event.preventDefault()
      this.hide()
    }
  }

  toggleConfirm(event) {
    this.setSubmitDisabled(!event.target.checked)
  }

  setSubmitDisabled(disabled) {
    if (!this.hasSubmitTarget) return
    const control = this.submitTarget.querySelector("button, a")
    if (!control) return
    if (disabled) {
      control.setAttribute("disabled", "disabled")
      control.classList.add("is-disabled")
    } else {
      control.removeAttribute("disabled")
      control.classList.remove("is-disabled")
    }
  }

  show = (event) => {
    lock(document.body)
    document.dispatchEvent(new Event('document:lock'))
    this.element.classList.add("active")
  }

  hide = () => {
    this.element.classList.remove("active")
    unlock(document.body)
    document.dispatchEvent(new Event('document:unlock'))
  }
}
